//-- React Standard
import { Badge, Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Fade, Row, FormGroup, Label, Input } from 'reactstrap';
import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import config from '../../config';
import { apiConstants } from '../../_constants/api.constants';

//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import { withStyles } from "@material-ui/core/styles";
import Footer from "../Common/Footer/Footer";
import { outletActions } from "../../_actions";

//-- CSS for Material
const styles = theme => ({
    error: {
        color: 'red',
    }
});

class Outlets extends Component {
    constructor(props) {
        super(props);

        this.state = {
            getAllOutlets: []
        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(outletActions.getAllOutlets(apiConstants.GET_OUTLETS, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    * componenentDidUpdate()
    */
    componentWillReceiveProps(props) {
        if (props.getAllOutlets) {
            if (props.getAllOutlets.getAllOutlets) {
                if (props.getAllOutlets.getAllOutlets.data) {

                    this.setState({
                        totalPage: props.getAllOutlets.getAllOutlets.data.totalPages,
                        totalDataCount: props.getAllOutlets.getAllOutlets.data.totalCount,
                        getAllOutlets: props.getAllOutlets.getAllOutlets.data,
                    })
                }
            }
        }
    }

    //-- Main function
    render() {
        const { match } = this.props;

        const { siteConstants } = this.props.language;
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_OUTLETS}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <Card>
                                        <CardHeader>
                                            <strong>{siteConstants.MENU_OUTLETS}</strong>
                                        </CardHeader>
                                        <CardBody>
                                            <Card className="mb-2">
                                                <CardBody>
                                                    <Row className="mb-4">
                                                        {
                                                            this.state.getAllOutlets != undefined && this.state.getAllOutlets.length > 0 ? this.state.getAllOutlets.map((outlets, index) => {
                                                                return (
                                                                    <Fragment>
                                                                        <Col xs="1" style={{ textAlign: "right" }}>
                                                                            <i className="fa fa-laptop"></i>
                                                                        </Col>
                                                                        <Col xs="3">
                                                                            <FormGroup>
                                                                                <a href="javascript:void(0);" className="fontBold">{outlets.name}</a>
                                                                                <div>{outlets.contact_person} ({outlets.contact_email})</div>
                                                                                <div>{outlets.description}</div>
                                                                            </FormGroup>
                                                                        </Col>
                                                                    </Fragment>
                                                                )
                                                            }) :
                                                                <div className="noRecordFound">{siteConstants.GEN_NO_RECORD}</div>
                                                        }
                                                    </Row>

                                                </CardBody>
                                            </Card>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}
                    <Footer />
                </div>
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, getAllOutlets } = state;
    return {
        language,
        getAllOutlets
    };
}
const connectedOutlets = connect(mapStateToProps)(withStyles(styles)(Outlets));
export { connectedOutlets as Outlets };
